import React from 'react';

import type { BICallbacks } from './../../ricos-types/index.js';

const BiHelpersContext = React.createContext<Partial<BICallbacks>>({});

export const BiHelpersProvider: React.FC<
  React.PropsWithChildren<{ helpers: Partial<BICallbacks> }>
> = ({ children, helpers }) => {
  return <BiHelpersContext.Provider value={helpers}>{children}</BiHelpersContext.Provider>;
};

export const useBiCallbacks = (): Partial<BICallbacks> => {
  return React.useContext(BiHelpersContext);
};
